import { Handle, Node, NodeProps, Position, useReactFlow } from '@xyflow/react';
import { Button, Select, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { GraphListEntry } from '../../client';
import { IODataType, NodeDataType } from './types';
import { CSSProperties } from 'react';

export type SubgraphNodeDataType = {
  subgraphId?: string;
  type: 'subgraph' | 'foreach';
  graphs: GraphListEntry[];
} & NodeDataType;

export type SubgraphNodeType = Node<SubgraphNodeDataType, 'Subgraph'>;

function SubgraphNode({
  id,
  data: { subgraphId, type, graphs },
  isConnectable,
}: NodeProps<SubgraphNodeType>) {
  const { updateNodeData } = useReactFlow();

  const onChange = (value: string) => {
    updateNodeData(id, { subgraphId: value });
  };

  const graph = subgraphId
    ? graphs.find((graph) => graph.id === subgraphId)
    : null;
  const inputs = graph?.inputs;

  const style: CSSProperties = {};
  const minHandleSpace = 15;
  let inputHandles;
  if (inputs && inputs.length) {
    // const space = 100 / inputs.length;
    const requiredSpace = minHandleSpace * inputs.length;
    if (requiredSpace > 100) {
      style.minWidth = requiredSpace;
    }
    const space = 100 / inputs.length;
    const halfspace = space / 2;
    inputHandles = inputs.map(({ dataType }, idx) => (
      <Tooltip title={`input-${idx}`} key={idx}>
        <Handle
          id={idx === 0 ? undefined : `input-${idx}`}
          key={idx}
          style={{ left: `${idx * space + halfspace}%` }}
          type="target"
          position={Position.Top}
          isConnectable={isConnectable}
          className={`data-type-${dataType}`}
        />
      </Tooltip>
    ));
  }

  const options = graphs.map((graph) => ({
    value: graph.id,
    label: graph.name,
  }));

  const selectId = `subgraph-${subgraphId}`;

  return (
    <div className={type === 'foreach' ? 'foreach-node' : 'subgraph-node'}>
      {inputHandles}

      <div>
        <label htmlFor={selectId}>
          {type === 'foreach' ? 'ForEach' : 'Subgraph'}
        </label>
        <Select
          id={selectId}
          onChange={onChange}
          className="nodrag subgraph-select"
          value={subgraphId}
          options={options}
          showSearch
        />
      </div>
      {subgraphId && (
        <div className="subgraph-edit-link">
          <Link to={`/graphs/${subgraphId}`}>
            <Button>Edit</Button>
          </Link>
        </div>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
      />
    </div>
  );
}

export default SubgraphNode;
